import { useCallback, useEffect, useRef, useState } from 'react';
import { TIPO_VISAO } from '~/modules/Helper/tipo-visao';
import { useDebounce } from '../../Helper/hooks/debounce.hook';

export function useGridFiltros({
  configuracao,
  filtrosParam,
  obterColunaChave,
  obterColunaLink,
}) {
  const [filtro, setFiltro] = useState([]);
  const filtroDebounce = useDebounce(filtro, 500);
  const [dataFilterHeader, setDataFilterHeader] = useState([]);
  const aplicouFiltrosFromUrlRef = useRef(false);

  useEffect(() => {
    if (aplicouFiltrosFromUrlRef.current) return;
    if (!configuracao) return;
    if (!Array.isArray(filtrosParam) || !filtrosParam.length) return;

    const colunaBusca =
      configuracao?.Tipo === TIPO_VISAO.AGRUPAMENTO
        ? obterColunaChave()
        : obterColunaLink();

    const campoBusca = colunaBusca?.FonteDados;

    const filtroBusca = campoBusca
      ? filtrosParam.find(f => f?.Campo === campoBusca)
      : null;

    const filtrosColuna = campoBusca
      ? filtrosParam.filter(f => f?.Campo !== campoBusca)
      : filtrosParam;

    setFiltro(filtroBusca ? [filtroBusca] : []);
    setDataFilterHeader({
      Filtros: filtrosColuna?.length ? filtrosColuna : null,
    });

    aplicouFiltrosFromUrlRef.current = true;
  }, [configuracao, filtrosParam, obterColunaChave, obterColunaLink]);

  const obterMergeFiltro = useCallback(() => {
    let mergeFiltro = [];
    let indexFiltro;

    if (dataFilterHeader?.Filtros && dataFilterHeader?.Filtros.length > 0) {
      mergeFiltro = dataFilterHeader.Filtros;

      if (filtroDebounce) {
        indexFiltro = mergeFiltro.findIndex(
          x => x.Campo == filtroDebounce[0]?.Campo
        );

        if (indexFiltro >= 0) {
          mergeFiltro = mergeFiltro.filter(
            item => item.Campo !== mergeFiltro[indexFiltro].Campo
          );
        }

        if (filtroDebounce.length > 0 && filtroDebounce[0].Valor !== '') {
          mergeFiltro.push(filtroDebounce[0]);
        }
      }

      if (filtroDebounce === -1 || filtroDebounce === undefined) {
        mergeFiltro = dataFilterHeader.Filtros;
      }
    } else {
      mergeFiltro =
        Array.isArray(dataFilterHeader?.Filtros) &&
        dataFilterHeader?.Filtros.length > 0
          ? dataFilterHeader?.Filtros
          : filtroDebounce;
    }

    return mergeFiltro;
  }, [dataFilterHeader, filtroDebounce]);

  return {
    dataFilterHeader,
    filtro,
    filtroDebounce,
    obterMergeFiltro,
    setDataFilterHeader,
    setFiltro,
  };
}
